<template>
  <b-overlay :show="loading" opacity="0.8">
    <validation-observer ref="newUserForm" #default="{invalid}">
      <b-form ref="form" @submit.prevent="onUpdateUser">
        <div :style="{
            height: readOnly ? '450px' : '600px', 
            borderBottom: readOnly ? '' : 'solid lightgray 2px'
          }"
        >
          <div v-if="!readOnly" class="d-flex align-items-center mb-3">
            <feather-icon
              icon="UsersIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              Family History
            </h4>
          </div>
  
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group>
                <validation-provider #default="{ errors }" name="Hypertension" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Hypertension</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="familyHistory.hypertension" 
                        name="hypertension" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Diabetes Mellitus" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Diabetes Mellitus</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="familyHistory.diabetes_mellitus" 
                        name="diabetes_mellitus" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Coronary Disease" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Coronary Disease</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="familyHistory.coronary_disease" 
                        name="coronary_disease" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Chronic Obstructive Lung Disease" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Chronic Obstructive Lung Disease</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="familyHistory.chronic_obstructive_lung_disease" 
                        name="chronic_obstructive_lung_disease" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Heart Failure" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Heart Failure</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="familyHistory.heart_failure" 
                        name="heart_failure" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Cancer" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Cancer</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="familyHistory.cancer" 
                        name="cancer" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group v-if="familyHistory.cancer">
                <validation-provider #default="{ errors }" name="Type of cancer" rules="required">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Type of cancer<span style="color: tomato">*</span></label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <cancer-select 
                        :disabled="disableForm"
                        :value="familyHistory.type_of_cancer_id"
                        @change="val => familyHistory.type_of_cancer_id = val"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Bronchial Asthma" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Bronchial Asthma</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="familyHistory.bronchial_asthma" 
                        name="bronchial_asthma" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Peptic Ulcer Disease" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Peptic Ulcer Disease</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="familyHistory.peptic_ulcer_disease" 
                        name="peptic_ulcer_disease" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Hypercholesterolaemia" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Hypercholesterolaemia</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="familyHistory.hypercholesterolaemia" 
                        name="hypercholesterolaemia" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <b-button
          v-if="!readOnly"
          class="float-right mt-2"
          style="width: 200px"
          variant="primary"
          block
          type="submit"
          :disabled="invalid || disableForm || loading"
        >
          Update
        </b-button>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BFormCheckbox,
  BForm, BFormInput, BMedia, BAvatar,
  BFormFile, BFormDatepicker, BBadge,
  BOverlay, BAlert, BLink, BRow, BCol,
  BCard, BCardBody, BButton, BFormGroup, 
  BInputGroup, BInputGroupPrepend, BDropdown,
  BDropdownItem, BFormSelect, BFormInvalidFeedback
} from "bootstrap-vue"

import { get, cloneDeep } from 'lodash';
import { required } from '@validations';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import CancerSelect from "@core/components/shared/admin/selects/CancerSelect.vue"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    BFormCheckbox,
    BOverlay,
    BAlert,
    BLink,
    BRow,
    BCol,
    BCard, 
    BForm, 
    BMedia, 
    BBadge,
    BAvatar,
    BButton,
    BCardBody, 
    BFormFile,
    BDropdown,
    BFormInput,
    BFormGroup, 
    BInputGroup,
    BFormSelect,
    BDropdownItem,
    BFormDatepicker,
    BInputGroupPrepend,
    BFormInvalidFeedback,
    
    // validations
    ValidationProvider,
    ValidationObserver,

    CancerSelect
  },
  directives: {},
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    patientData: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data(){
    return {
      loading: false,

      familyHistory: null,

      required,
    }
  },
  computed: {
    hasBasicUpdatePermission(){
      return this.can('patients:CanUpdate');
    },
    disableForm(){
      return !this.can('patients:CanUpdate') || this.readOnly;
    },
  },
  watch: {
    patientData: {
      handler(data){
        this.familyHistory = {
          type_of_cancer_id: '',
          ...cloneDeep(data.family_history)
        };
      }, 
      immediate: false,
      deep: true
    }
  },
  created() {
    this.familyHistory = {
      type_of_cancer_id: '',
      ...cloneDeep(this.patientData.family_history)
    };
  },
  methods: {
    async onUpdateUser() {
      try {
        this.loading = true;

        await this.useJwt().mainService.patients.updateMedicalHistory(this.patientData.id, {
          family_history: this.familyHistory
        });
        this.$emit('refresh')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Patient profile updated successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            variant: 'danger',
            text: error_message,
            icon: 'AlertTriangleIcon',
          },
        });
      } finally {
        this.loading = false
      }
    },
    onImageRenderer(file) {
      const reader = new FileReader()

      reader.addEventListener(
          'load',
          () => {
            this.avatarPath = reader.result
            this.updatedImage = file;
          },
          false,
      )

      if (file) {
        reader.readAsDataURL(file)
      }
    },
  }
}
</script>
